import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import api3004 from '../../services/api3004';

const MySwal = withReactContent(Swal);

const ModalReservado = async () => {

  let options = '';

  try {

    const response = await api3004.get('/api/onibus');


    const onibus = response.data || [];


    options = onibus
      .map(o => {
        return `<option value="${o.id}">${o.prefixo} - ${o.placa}</option>`;
      })
      .join('');

  } catch (err) {
    Swal.fire('Erro', 'Erro ao carregar ônibus', 'error');
    return null;
  }

  const result = await MySwal.fire({
    title: 'Finalização da Viagem - Reservado',
    html: `
      <input 
        id="swal-motorista" 
        class="swal2-input" 
        placeholder="Motorista"
        maxlength="100"
      />
      <select id="swal-onibus" class="swal2-select">
        <option value="">Selecione o ônibus</option>
        ${options}
      </select>
    `,
    showCancelButton: true,
    confirmButtonText: 'Salvar',
    cancelButtonText: 'Cancelar',
    focusConfirm: false,

    preConfirm: () => {

      const motorista = document.getElementById('swal-motorista').value;

      const select = document.getElementById('swal-onibus');
      const onibus_id = select.value;

      if (!motorista || !onibus_id) {
        Swal.showValidationMessage('Todos os campos são obrigatórios');
        return false;
      }
      
      if (motorista.length > 100) {
        Swal.showValidationMessage('Máximo de 100 caracteres');
        return false;
      }

      const payload = {
        motorista,
        onibus_id: Number(onibus_id)
      };

      return payload;
    }
  });

  return result.isConfirmed ? result.value : null;
};

export default ModalReservado;